<script lang="ts" setup>
  import FlowLogo from '../FlowLogo/FlowLogo.vue'
  import RetrunArrowIcon from '@/shared/components/icons/RetrunArrowIcon.vue'
  import { useGoogleAnalytics } from '@/shared/composables/useGoogleAnalytics/useGoogleAnalytics'
  import { useFlow, useFlowSteps } from '@/shared/composables'
  import { useRoute } from 'vue-router'
  import { useHomeUrl } from '@/shared/composables/useHomeUrl'

  interface Props {
    href?: string
    withArrowBack?: boolean
    rtl?: boolean
  }
  interface Emits {
    (e: 'goBack'): void
  }

  const props = withDefaults(defineProps<Props>(), {
    withArrowBack: true,
    rtl: false,
  })

  const emit = defineEmits<Emits>()
  const gaService = useGoogleAnalytics()
  const flow = useFlow()
  const route = useRoute()
  const flowStep = useFlowSteps(flow.flowScheme)

  const onLogoClick = () => {
    gaService.sendToMainPage(flowStep.step.value.current || route.name)
  }
  const { getHomeUrl } = useHomeUrl()
  const homeUrl = getHomeUrl()
</script>

<template>
  <div class="header" :class="{ header_rtl: rtl }">
    <RetrunArrowIcon v-if="props.withArrowBack" class="header-return" @click="emit('goBack')" />
    <FlowLogo :href="props.href || homeUrl" :rtl="rtl" @click="onLogoClick" />
  </div>
</template>

<style scoped lang="scss">
  @import './FlowHeader';
</style>
